// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GxbD","name":"Header_name__2UIFS","birthday":"Header_birthday___hQO7","skeleton":"Header_skeleton__VSAnf"};